import { render, staticRenderFns } from "./studentLeave.vue?vue&type=template&id=841bceea&scoped=true&"
import script from "./studentLeave.vue?vue&type=script&lang=js&"
export * from "./studentLeave.vue?vue&type=script&lang=js&"
import style0 from "./studentLeave.vue?vue&type=style&index=0&id=841bceea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841bceea",
  null
  
)

export default component.exports